module.exports = __webpack_public_path__ + "img/MyDashboard.b34e7bca.svg";